import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { useAuth } from '../../../hooks/useAuth.js'
import { recibirUrlAutorizacion, recibirUserInfo } from '../../servicios/mercadoPagoService'
import styles from './VincularMercadoPago.module.css'

export const VincularMercadoPago = ({ empid }) => {
  const [authUrl, setAuthUrl] = useState('')
  const [loading, setLoading] = useState(true)
  const [userMP, setUserMP] = useState('')
  const { esPerfilAdmin } = useAuth()

  const fetchAuthUrl = async (tieneCuenta) => {
    try {
      const { data } = await recibirUrlAutorizacion({ empid })
      setAuthUrl(data?.body?.url ?? '')
    } catch (error) {
      if (tieneCuenta) {
        const mensaje = `Ocurrió un error al obtener la URL de autorización de Mercado Pago.`
        toastErrorLog(error, mensaje, 'mercadoPago')
      }
    }
  }

  const fetchUserInfo = async () => {
    try {
      const { data } = await recibirUserInfo({ empid })
      setUserMP(`${data.body.first_name} ${data.body.last_name}(${data.body.nickname})`)
      return true
    } catch {
      toast.info('No se encontró usuario asociado de MP')
      return false
    }
  }

  const cargar = async () => {
    try {
      const tieneCuenta = await fetchUserInfo()
      await fetchAuthUrl(tieneCuenta)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!empid) {
      setLoading(false)
      return
    }
    cargar()
  }, [empid])

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>Mercado Pago</h4>

      <p className={styles.description}>
        Vinculá tu cuenta para poder recibir pagos de forma automática.
        <br /> Una vez realizada la vinculación, recordá configurar los plazos de cobro en tu panel
        de Mercado Pago.
      </p>

      <div className={styles.mpUser}>
        {esPerfilAdmin && (
          <a
            href={loading ? undefined : authUrl}
            className={`${styles.button} ${loading ? styles.buttonDisabled : ''}`}
            aria-disabled={loading}
          >
            {loading ? 'Cargando...' : 'Vincular cuenta'}
          </a>
        )}
        <div>
          Usuario vinculado:
          {userMP === '' ? (
            <span className={styles.statusVoid}> No tenés una cuenta vinculada</span>
          ) : (
            <span className={styles.status}> {userMP}</span>
          )}
        </div>
      </div>
    </div>
  )
}

VincularMercadoPago.propTypes = {
  empid: PropTypes.string
}
